import { FC } from 'react'
import { useRouter } from 'next/router'

import DhlIcon from './DhlIcon'
import DpdIcon from './DpdIcon'
import FedExIcon from './FedExIcon'
import GlsIcon from './GlsIcon'
import UpsIcon from './UpsIcon'
import BudbeeIcon from './BudbeeIcon'
import MatkahuoltoIcon from './MatkahuoltoIcon'
import PostnordIcon from './PostnordIcon'
import PostiIcon from './PostiIcon'
import SchenkerIcon from './SchenkerIcon'
import { getCountryAndLocaleStrings } from '../../../../utils/locales'

import styles from '../../../../styles/Footer.module.less'

const ShippingServiceLogos: FC = () => {
  const { locale: countryAndLocale } = useRouter()
  const { country } = getCountryAndLocaleStrings(countryAndLocale)

  const renderLogos = () => {
    switch (country) {
      case 'fi':
        return (
          <>
            <PostiIcon />
            <MatkahuoltoIcon />
            <PostnordIcon />
            <UpsIcon />
            <FedExIcon />
            <DhlIcon />
            <BudbeeIcon />
          </>
        )
      case 'sv':
        return (
          <>
            <PostnordIcon />
            <SchenkerIcon />
            <DhlIcon />
            <UpsIcon />
            <FedExIcon />
          </>
        )
      default:
        return (
          <>
            <DhlIcon />
            <DpdIcon />
            <GlsIcon />
            <UpsIcon />
            <FedExIcon />
          </>
        )
    }
  }

  return <div className={styles['icons-container']}>{renderLogos()}</div>
}

export default ShippingServiceLogos
